import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const postNewsArticleLike = async (id: number) => {
  const response: AxiosResponse = await apiInstance.post(`/news/${id}/like`);

  return response.data;
};
